// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminDashboard-commonHeaderAdmin-ASeWs {
	position: fixed !important;
}

.AdminDashboard-adminLayout-TV5Ol {
	padding-top: 64px !important;
}

.AdminDashboard-box-cZkSX h2 {
	font-size: 21px;
	font-weight: 600;
}

.AdminDashboard-exportLink-HKqEG {
	margin-bottom: -29px;
}

.AdminDashboard-blockCenter-olcfe {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.AdminDashboard-panelHeader-HcruN {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.AdminDashboard-currencyselect-ucKnL {
	width: 100%;
	margin-right: 0px;
}

.AdminDashboard-panelHeader-HcruN {
	overflow: hidden;
	position: relative;
}

.AdminDashboard-mar0-rUFSq {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.AdminDashboard-blockCenter-olcfe {
		padding: 0px;
	}

	.AdminDashboard-panelHeader-HcruN {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.AdminDashboard-sideAdminPageWrapper-jGii1 {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.AdminDashboard-panelHeader-HcruN {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.AdminDashboard-table-OA1sV {
	display: table;
}

.AdminDashboard-tableRow-L7xZ_ {
	display: table-row;
}

.AdminDashboard-tableCell-fpWc8 {
	display: table-cell;
	float: none;
}

.AdminDashboard-formGroup-IbaeP {
	margin-bottom: 6px;
}

.AdminDashboard-select-bUbaD {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.AdminDashboard-noMargin-Sa1ha {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.AdminDashboard-exportLink-HKqEG {
	padding-top: 10px;
	padding-right: 10px;
}

.AdminDashboard-labelTextNew-WDoI6 {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.AdminDashboard-displayInline-z4XRc {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.AdminDashboard-btnUPdate-uYaB6 {
	display: inline-block;
}

.AdminDashboard-btnModalDelete-fEb1e {
	display: inline-block;
	margin-left: 15px;
}

.AdminDashboard-radioBtn-sOwRg {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.AdminDashboard-backgroundImg-oV7Pr {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.AdminDashboard-btnUPdate-uYaB6 {
		display: block;
		margin-bottom: 12px;
	}

	.AdminDashboard-btnModalDelete-fEb1e {
		display: block;
		margin-left: 0px;
	}

	.AdminDashboard-btnWidth-uKqP1 {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.AdminDashboard-bannerImageBg-yG1o2 {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.AdminDashboard-bannerDelete-l6fp6 {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.AdminDashboard-modalRoot-uf2OG {
	padding: 32px;
}

.AdminDashboard-modalBorderBottom-C09wD {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.AdminDashboard-logInModalBody-iRDiS {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.AdminDashboard-exportSection-d592N {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.AdminDashboard-exportSectionGridSub-eCrBy {
	grid-template-columns: 50% 49% !important;
}

.AdminDashboard-exportText-o8sTh {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.AdminDashboard-exportLinkImg-vlMzg {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.AdminDashboard-vtrMiddle-AVmpk {
	vertical-align: middle;
}

.AdminDashboard-exportImg-kgNWM {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.AdminDashboard-profileViewlabel-RAjH7 {
	display: inline-block;
	width: 38%
}

.AdminDashboard-profileViewMainContent-xwZvC {
	display: inline-block;
	width: 62%;
}

.AdminDashboard-profileViewMain-jzxmy {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.AdminDashboard-profileViewInner-g2Y1D {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.AdminDashboard-profileImageSection-bj1Rm {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.AdminDashboard-lastviewInner-O7RP9 {
	padding: 10px;
}

.AdminDashboard-whyHostHoriLine-jb8on {
	margin: 30px 0;
}

.AdminDashboard-tableGrid-Y0Ez0 {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.AdminDashboard-headingContent-VU09J {
	font-size: 18px;
	font-weight: 500;
}

.AdminDashboard-refundTextColor-cfUuq {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.AdminDashboard-dividerLine-ZIhb1 {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.AdminDashboard-smallContent-dcOcQ {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.AdminDashboard-sideAdminPageWrapper-jGii1 {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.AdminDashboard-sideAdminPageWrapper-jGii1 {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.AdminDashboard-exportSection-d592N {
		grid-template-columns: 100%;
	}

	.AdminDashboard-exportSectionGridSub-eCrBy {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.AdminDashboard-profileViewlabel-RAjH7 {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.AdminDashboard-profileViewMainContent-xwZvC {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.AdminDashboard-ChangeToUpperCase-Jox2T {
	text-transform: uppercase
}

.AdminDashboard-noBorder-tzIZE {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.AdminDashboard-siteAdminHeading-DObEV {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.AdminDashboard-siteAdminSubHeading-Ue_M8 {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.AdminDashboard-adminFormDivider-Upuix {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

/** Dashboard - Start **/

.AdminDashboard-userBox-z48Me {
	min-height: 200px;
	padding: 25px 20px 20px;
	border-radius: 5px;
	background: linear-gradient(123deg, rgba(255, 88, 86, 1) 0%, rgba(249, 30, 136, 1) 100%);
	-webkit-box-shadow: -1px 7px 26px -1px var(--primary-box-shadow);
	        box-shadow: -1px 7px 26px -1px var(--primary-box-shadow);
}

.AdminDashboard-userImg-AWO56 img {
	width: 80px;
	height: 80px;
}

.AdminDashboard-userContent-Eu4_x h2 {
	font-size: 16px;
	margin: 0;
}

.AdminDashboard-userContent-Eu4_x div {
	font-size: 34px;
	color: #fff;
	font-weight: 600;
	letter-spacing: 2px;
	margin-top: 3px;
}

.AdminDashboard-userImg-AWO56 {
	width: 40%;
	vertical-align: top;
	text-align: center;
}

.AdminDashboard-userContent-Eu4_x {
	width: 60%;
	text-align: center;
	color: #fff;
	padding-top: 8px;
}

.AdminDashboard-graph-Zf5QF {
	margin-top: 25px;
}

.AdminDashboard-graph-Zf5QF img {
	width: 100%;
}

.AdminDashboard-lastedBox-PDY1K {
	background: linear-gradient(123deg, rgba(255, 207, 27, 1) 0%, rgba(255, 136, 24, 1) 100%);
	-webkit-box-shadow: -1px 7px 26px -1px var(--primary-box-shadow);
	        box-shadow: -1px 7px 26px -1px var(--primary-box-shadow);
}

.AdminDashboard-motheBox-rWJ9G {
	background: linear-gradient(123deg, rgba(15, 196, 226, 1) 0%, rgba(100, 84, 240, 1) 100%);
}

.AdminDashboard-motheListing-wMWbR {
	background: var(--background-primary);
	padding: 20px 30px;
	border-radius: 5px;
	min-height: 150px;
	-webkit-box-shadow: -1px 7px 26px -1px var(--primary-box-shadow);
	        box-shadow: -1px 7px 26px -1px var(--primary-box-shadow);
}

.AdminDashboard-listingImg-qIKge img {
	width: 70px;
}

.AdminDashboard-listingImg-qIKge {
	vertical-align: top;
}

.AdminDashboard-listingContent-AMo0Y {
	padding-left: 20px;
	padding-top: 5px;
	width: 66%;
}

.AdminDashboard-listingContent-AMo0Y h2 {
	font-size: 16px;
	margin: 0;
}

.AdminDashboard-listingContent-AMo0Y div {
	font-size: 34px;
	font-weight: 600;
	margin-top: 3px;
}

.AdminDashboard-hourListing-kME0C {
	margin-top: 25px;
}

.AdminDashboard-listingSectionMain-jkJ6S {
	margin-top: 35px;
}

.AdminDashboard-reservationIcon-YxTKk img {
	width: 35px;
}

.AdminDashboard-totalReservation-gD7dP {
	background: var(--background-primary);
	position: relative;
	-webkit-box-shadow: -1px 7px 26px -1px var(--primary-box-shadow);
	        box-shadow: -1px 7px 26px -1px var(--primary-box-shadow);
	border-radius: 5px;
}

.AdminDashboard-reservationHeader-ePg3w {
	font-size: 16px;
	padding: 25px 5px;
	text-align: center;
	-webkit-box-shadow: -1px 7px 26px -1px var(--primary-box-shadow);
	        box-shadow: -1px 7px 26px -1px var(--primary-box-shadow);
	border-bottom: 1px solid var(--primary-border);
}

.AdminDashboard-reservationContent-ns5Pk {
	padding-left: 5px;
}

.AdminDashboard-reservationBottom-La0hT {
	min-height: 165px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	font-size: 34px;
	letter-spacing: 2px;
	position: relative;
	z-index: 2;
	color: #000FD4;
}

.AdminDashboard-reservationCircle-dPbK8 {
	width: 200px;
	height: 100px;
	background-color: #EEF9FF;
	border-top-left-radius: 110px;
	border-top-right-radius: 110px;
	border-bottom: 0;
	position: absolute;
	left: 0;
	right: 0;
	text-align: center;
	bottom: 0px;
	margin: 0 auto;
	z-index: 1;
}

.AdminDashboard-reservation24-pOcLx {
	color: #D400AF;
}

.AdminDashboard-reservationCircle24-OujJS {
	background-color: #FFF1FD;
}

.AdminDashboard-reservation30-hnnUu {
	color: #FF7709;
}

.AdminDashboard-reservationCircle30-l0ZSe {
	background-color: #FFFED3;
}

.AdminDashboard-displayInline-z4XRc {
	display: inline-block;
}

@media (max-width: 1200px) and (min-width: 992px) {
	.AdminDashboard-displayBlock-DhkFK {
		display: block;
	}

	.AdminDashboard-motheListing-wMWbR {
		padding: 20px 15px;
		text-align: center;
		min-height: 200px;
	}

	.AdminDashboard-listingContent-AMo0Y {
		padding-left: 0px;
		padding-top: 8px;
		width: 100%;
	}

	.AdminDashboard-totalReservation-gD7dP {
		min-height: 300px;
	}
}

@media (max-width:1199px) and (min-width:1024px) {
	.AdminDashboard-motheListing-wMWbR {
		min-height: auto;
	}

	.AdminDashboard-reservationHeader-ePg3w {
		max-height: 123px;
		min-height: 123px;
	}

	.AdminDashboard-userContent-Eu4_x {
		padding-left: 8px;
	}
}

@media (max-width: 991px) {
	.AdminDashboard-userBox-z48Me {
		margin-bottom: 20px;
	}

	.AdminDashboard-totalReservation-gD7dP {
		margin-bottom: 20px;
	}

	.AdminDashboard-mobileMargin-ZWUP3 {
		margin-bottom: 20px;
	}
}

@media (max-width: 767px) {
	.AdminDashboard-container-_BTnP {
		width: 100%;
	}

	.AdminDashboard-listingContent-AMo0Y {
		width: 60%;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/AdminDashboard/AdminDashboard.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACrUA,wBAAwB;;AACxB;CACC,iBAAiB;CACjB,uBAAuB;CACvB,kBAAkB;CAClB,wFAAwF;CACxF,gEAAwD;SAAxD,wDAAwD;AACzD;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,eAAe;CACf,SAAS;AACV;;AAEA;CACC,eAAe;CACf,WAAW;CACX,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,UAAU;CACV,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,UAAU;CACV,kBAAkB;CAClB,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,yFAAyF;CACzF,gEAAwD;SAAxD,wDAAwD;AACzD;;AAEA;CACC,yFAAyF;AAC1F;;AAEA;CACC,qCAAqC;CACrC,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,gEAAwD;SAAxD,wDAAwD;AACzD;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,eAAe;CACf,SAAS;AACV;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,qCAAqC;CACrC,kBAAkB;CAClB,gEAAwD;SAAxD,wDAAwD;CACxD,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,gEAAwD;SAAxD,wDAAwD;CACxD,8CAA8C;AAC/C;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;CACjB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,eAAe;CACf,mBAAmB;CACnB,kBAAkB;CAClB,UAAU;CACV,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,yBAAyB;CACzB,6BAA6B;CAC7B,8BAA8B;CAC9B,gBAAgB;CAChB,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,kBAAkB;CAClB,WAAW;CACX,cAAc;CACd,UAAU;AACX;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC;EACC,cAAc;CACf;;CAEA;EACC,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;CACZ;;CAEA;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,iBAAiB;EACjB,iBAAiB;CAClB;;CAEA;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;AACD;;AAEA;CACC;EACC,WAAW;CACZ;;CAEA;EACC,UAAU;CACX;AACD","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}","@import '../admin-common.css';\n\n/** Dashboard - Start **/\n.userBox {\n\tmin-height: 200px;\n\tpadding: 25px 20px 20px;\n\tborder-radius: 5px;\n\tbackground: linear-gradient(123deg, rgba(255, 88, 86, 1) 0%, rgba(249, 30, 136, 1) 100%);\n\tbox-shadow: -1px 7px 26px -1px var(--primary-box-shadow);\n}\n\n.userImg img {\n\twidth: 80px;\n\theight: 80px;\n}\n\n.userContent h2 {\n\tfont-size: 16px;\n\tmargin: 0;\n}\n\n.userContent div {\n\tfont-size: 34px;\n\tcolor: #fff;\n\tfont-weight: 600;\n\tletter-spacing: 2px;\n\tmargin-top: 3px;\n}\n\n.userImg {\n\twidth: 40%;\n\tvertical-align: top;\n\ttext-align: center;\n}\n\n.userContent {\n\twidth: 60%;\n\ttext-align: center;\n\tcolor: #fff;\n\tpadding-top: 8px;\n}\n\n.graph {\n\tmargin-top: 25px;\n}\n\n.graph img {\n\twidth: 100%;\n}\n\n.lastedBox {\n\tbackground: linear-gradient(123deg, rgba(255, 207, 27, 1) 0%, rgba(255, 136, 24, 1) 100%);\n\tbox-shadow: -1px 7px 26px -1px var(--primary-box-shadow);\n}\n\n.motheBox {\n\tbackground: linear-gradient(123deg, rgba(15, 196, 226, 1) 0%, rgba(100, 84, 240, 1) 100%);\n}\n\n.motheListing {\n\tbackground: var(--background-primary);\n\tpadding: 20px 30px;\n\tborder-radius: 5px;\n\tmin-height: 150px;\n\tbox-shadow: -1px 7px 26px -1px var(--primary-box-shadow);\n}\n\n.listingImg img {\n\twidth: 70px;\n}\n\n.listingImg {\n\tvertical-align: top;\n}\n\n.listingContent {\n\tpadding-left: 20px;\n\tpadding-top: 5px;\n\twidth: 66%;\n}\n\n.listingContent h2 {\n\tfont-size: 16px;\n\tmargin: 0;\n}\n\n.listingContent div {\n\tfont-size: 34px;\n\tfont-weight: 600;\n\tmargin-top: 3px;\n}\n\n.hourListing {\n\tmargin-top: 25px;\n}\n\n.listingSectionMain {\n\tmargin-top: 35px;\n}\n\n.reservationIcon img {\n\twidth: 35px;\n}\n\n.totalReservation {\n\tbackground: var(--background-primary);\n\tposition: relative;\n\tbox-shadow: -1px 7px 26px -1px var(--primary-box-shadow);\n\tborder-radius: 5px;\n}\n\n.reservationHeader {\n\tfont-size: 16px;\n\tpadding: 25px 5px;\n\ttext-align: center;\n\tbox-shadow: -1px 7px 26px -1px var(--primary-box-shadow);\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.reservationContent {\n\tpadding-left: 5px;\n}\n\n.reservationBottom {\n\tmin-height: 165px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tfont-size: 34px;\n\tletter-spacing: 2px;\n\tposition: relative;\n\tz-index: 2;\n\tcolor: #000FD4;\n}\n\n.reservationCircle {\n\twidth: 200px;\n\theight: 100px;\n\tbackground-color: #EEF9FF;\n\tborder-top-left-radius: 110px;\n\tborder-top-right-radius: 110px;\n\tborder-bottom: 0;\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\ttext-align: center;\n\tbottom: 0px;\n\tmargin: 0 auto;\n\tz-index: 1;\n}\n\n.reservation24 {\n\tcolor: #D400AF;\n}\n\n.reservationCircle24 {\n\tbackground-color: #FFF1FD;\n}\n\n.reservation30 {\n\tcolor: #FF7709;\n}\n\n.reservationCircle30 {\n\tbackground-color: #FFFED3;\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n@media (max-width: 1200px) and (min-width: 992px) {\n\t.displayBlock {\n\t\tdisplay: block;\n\t}\n\n\t.motheListing {\n\t\tpadding: 20px 15px;\n\t\ttext-align: center;\n\t\tmin-height: 200px;\n\t}\n\n\t.listingContent {\n\t\tpadding-left: 0px;\n\t\tpadding-top: 8px;\n\t\twidth: 100%;\n\t}\n\n\t.totalReservation {\n\t\tmin-height: 300px;\n\t}\n}\n\n@media (max-width:1199px) and (min-width:1024px) {\n\t.motheListing {\n\t\tmin-height: auto;\n\t}\n\n\t.reservationHeader {\n\t\tmax-height: 123px;\n\t\tmin-height: 123px;\n\t}\n\n\t.userContent {\n\t\tpadding-left: 8px;\n\t}\n}\n\n@media (max-width: 991px) {\n\t.userBox {\n\t\tmargin-bottom: 20px;\n\t}\n\n\t.totalReservation {\n\t\tmargin-bottom: 20px;\n\t}\n\n\t.mobileMargin {\n\t\tmargin-bottom: 20px;\n\t}\n}\n\n@media (max-width: 767px) {\n\t.container {\n\t\twidth: 100%;\n\t}\n\n\t.listingContent {\n\t\twidth: 60%;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `AdminDashboard-commonHeaderAdmin-ASeWs`,
	"adminLayout": `AdminDashboard-adminLayout-TV5Ol`,
	"box": `AdminDashboard-box-cZkSX`,
	"exportLink": `AdminDashboard-exportLink-HKqEG`,
	"blockCenter": `AdminDashboard-blockCenter-olcfe`,
	"panelHeader": `AdminDashboard-panelHeader-HcruN`,
	"currencyselect": `AdminDashboard-currencyselect-ucKnL`,
	"mar0": `AdminDashboard-mar0-rUFSq`,
	"sideAdminPageWrapper": `AdminDashboard-sideAdminPageWrapper-jGii1`,
	"table": `AdminDashboard-table-OA1sV`,
	"tableRow": `AdminDashboard-tableRow-L7xZ_`,
	"tableCell": `AdminDashboard-tableCell-fpWc8`,
	"formGroup": `AdminDashboard-formGroup-IbaeP`,
	"select": `AdminDashboard-select-bUbaD`,
	"noMargin": `AdminDashboard-noMargin-Sa1ha`,
	"labelTextNew": `AdminDashboard-labelTextNew-WDoI6`,
	"displayInline": `AdminDashboard-displayInline-z4XRc`,
	"btnUPdate": `AdminDashboard-btnUPdate-uYaB6`,
	"btnModalDelete": `AdminDashboard-btnModalDelete-fEb1e`,
	"radioBtn": `AdminDashboard-radioBtn-sOwRg`,
	"backgroundImg": `AdminDashboard-backgroundImg-oV7Pr`,
	"btnWidth": `AdminDashboard-btnWidth-uKqP1`,
	"bannerImageBg": `AdminDashboard-bannerImageBg-yG1o2`,
	"bannerDelete": `AdminDashboard-bannerDelete-l6fp6`,
	"modalRoot": `AdminDashboard-modalRoot-uf2OG`,
	"modalBorderBottom": `AdminDashboard-modalBorderBottom-C09wD`,
	"logInModalBody": `AdminDashboard-logInModalBody-iRDiS`,
	"exportSection": `AdminDashboard-exportSection-d592N`,
	"exportSectionGridSub": `AdminDashboard-exportSectionGridSub-eCrBy`,
	"exportText": `AdminDashboard-exportText-o8sTh`,
	"exportLinkImg": `AdminDashboard-exportLinkImg-vlMzg`,
	"vtrMiddle": `AdminDashboard-vtrMiddle-AVmpk`,
	"exportImg": `AdminDashboard-exportImg-kgNWM`,
	"profileViewlabel": `AdminDashboard-profileViewlabel-RAjH7`,
	"profileViewMainContent": `AdminDashboard-profileViewMainContent-xwZvC`,
	"profileViewMain": `AdminDashboard-profileViewMain-jzxmy`,
	"profileViewInner": `AdminDashboard-profileViewInner-g2Y1D`,
	"profileImageSection": `AdminDashboard-profileImageSection-bj1Rm`,
	"lastviewInner": `AdminDashboard-lastviewInner-O7RP9`,
	"whyHostHoriLine": `AdminDashboard-whyHostHoriLine-jb8on`,
	"tableGrid": `AdminDashboard-tableGrid-Y0Ez0`,
	"headingContent": `AdminDashboard-headingContent-VU09J`,
	"refundTextColor": `AdminDashboard-refundTextColor-cfUuq`,
	"dividerLine": `AdminDashboard-dividerLine-ZIhb1`,
	"smallContent": `AdminDashboard-smallContent-dcOcQ`,
	"ChangeToUpperCase": `AdminDashboard-ChangeToUpperCase-Jox2T`,
	"noBorder": `AdminDashboard-noBorder-tzIZE`,
	"siteAdminHeading": `AdminDashboard-siteAdminHeading-DObEV`,
	"siteAdminSubHeading": `AdminDashboard-siteAdminSubHeading-Ue_M8`,
	"adminFormDivider": `AdminDashboard-adminFormDivider-Upuix`,
	"userBox": `AdminDashboard-userBox-z48Me`,
	"userImg": `AdminDashboard-userImg-AWO56`,
	"userContent": `AdminDashboard-userContent-Eu4_x`,
	"graph": `AdminDashboard-graph-Zf5QF`,
	"lastedBox": `AdminDashboard-lastedBox-PDY1K`,
	"motheBox": `AdminDashboard-motheBox-rWJ9G`,
	"motheListing": `AdminDashboard-motheListing-wMWbR`,
	"listingImg": `AdminDashboard-listingImg-qIKge`,
	"listingContent": `AdminDashboard-listingContent-AMo0Y`,
	"hourListing": `AdminDashboard-hourListing-kME0C`,
	"listingSectionMain": `AdminDashboard-listingSectionMain-jkJ6S`,
	"reservationIcon": `AdminDashboard-reservationIcon-YxTKk`,
	"totalReservation": `AdminDashboard-totalReservation-gD7dP`,
	"reservationHeader": `AdminDashboard-reservationHeader-ePg3w`,
	"reservationContent": `AdminDashboard-reservationContent-ns5Pk`,
	"reservationBottom": `AdminDashboard-reservationBottom-La0hT`,
	"reservationCircle": `AdminDashboard-reservationCircle-dPbK8`,
	"reservation24": `AdminDashboard-reservation24-pOcLx`,
	"reservationCircle24": `AdminDashboard-reservationCircle24-OujJS`,
	"reservation30": `AdminDashboard-reservation30-hnnUu`,
	"reservationCircle30": `AdminDashboard-reservationCircle30-l0ZSe`,
	"displayBlock": `AdminDashboard-displayBlock-DhkFK`,
	"mobileMargin": `AdminDashboard-mobileMargin-ZWUP3`,
	"container": `AdminDashboard-container-_BTnP`
};
module.exports = ___CSS_LOADER_EXPORT___;
